import React, { useState, useEffect } from 'react';
import './EnquiryForm.css';
import { FaSpinner, FaCheckCircle, FaTimes, FaPaperPlane } from 'react-icons/fa';

const EnquiryForm = ({ isOpen, onClose, isWelcomePopup = false, prabhujiImage }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    emailAddress: '',
    phoneNumber: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState({ loading: false, error: null, success: false });

  // Check if form should be shown based on localStorage
  useEffect(() => {
    if (isOpen && isWelcomePopup) {
      const hasClosedForm = localStorage.getItem('enquiryFormClosed');
      if (hasClosedForm === 'true') {
        onClose();
      }
    }
  }, [isOpen, isWelcomePopup, onClose]);

  const handleClose = () => {
    if (isWelcomePopup) {
      localStorage.setItem('enquiryFormClosed', 'true');
    }
    onClose();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus({ loading: true, error: null, success: false });

    try {
      const response = await fetch('https://tstock.trillionstechsolutions.com/enquiry-files/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.error || 'Failed to submit enquiry');
      }

      const result = await response.json();
      console.log('Submission successful:', result);
      setSubmitStatus({ loading: false, error: null, success: true });

      // Reset form after successful submission
      setFormData({
        fullName: '',
        emailAddress: '',
        phoneNumber: '',
        message: ''
      });

      // Close the form after 2 seconds on success
      setTimeout(() => {
        handleClose();
      }, 2000);

    } catch (error) {
      console.error('Error submitting enquiry:', error);
      setSubmitStatus({
        loading: false,
        error: error.message || 'Failed to submit enquiry. Please try again.',
        success: false
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="enquiry-modal-overlay">
      <div className="enquiry-modal">
        <div className="prabhuji-image-container">
          <img src={prabhujiImage} alt="" />
        </div>
        <div className="enquiry-content">
          <button className="enquiry-close-btn" onClick={handleClose}>×</button>
          <div className="enquiry-header">
            <h2>{isWelcomePopup ? 'Welcome to Trillions!' : 'Request Call Support'}</h2>
            <p>
              {isWelcomePopup 
                ? 'Get started with a free call from our team. Fill out the form below and we\'ll get back to you shortly.'
                : 'Get started with a free call from our team. Fill out the form below and we\'ll get back to you shortly.'
            }
            </p>
          </div>

          {submitStatus.error && (
            <div className="status-message error-message">
              <FaTimes className="status-icon" />
              {submitStatus.error}
            </div>
          )}

          {submitStatus.success && (
            <div className="status-message success-message">
              <FaCheckCircle className="status-icon" />
              Thank you for your interest! We'll contact you soon.
            </div>
          )}

          <form onSubmit={handleSubmit} className="enquiry-form">
            <div className="form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
                placeholder="Enter your full name"
                disabled={submitStatus.loading || submitStatus.success}
              />
            </div>
            <div className="form-group">
              <label htmlFor="emailAddress">Email Address</label>
              <input
                type="email"
                id="emailAddress"
                name="emailAddress"
                value={formData.emailAddress}
                onChange={handleChange}
                required
                placeholder="Enter your email"
                disabled={submitStatus.loading || submitStatus.success}
              />
            </div>
            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number</label>
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
                placeholder="Enter your phone number"
                disabled={submitStatus.loading || submitStatus.success}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message (Optional)</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder={isWelcomePopup 
                  ? "Tell us about your investment goals"
                  : "Any specific requirements or questions?"}
                rows="3"
                disabled={submitStatus.loading || submitStatus.success}
              />
            </div>
            <button 
              type="submit" 
              className="enquiry-submit-btn"
              disabled={submitStatus.loading || submitStatus.success}
            >
              {submitStatus.loading ? (
                <>
                  <FaSpinner className="spinner" />
                  Submitting...
                </>
              ) : submitStatus.success ? (
                <>
                  <FaCheckCircle />
                  Submitted Successfully
                </>
              ) : (
                <>
                  <FaPaperPlane />
                  {isWelcomePopup ? 'Get Free Call' : 'Request Call Back'}
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EnquiryForm; 